/* Feather Footwear — "Buy now" under Add to cart (product page + quick view).
   Adds the chosen size to the cart, then goes straight to checkout. */
(function () {
  'use strict';
  var LABEL = 'Buy now';

  function addThenCheckout(id, btn) {
    btn.disabled = true;
    btn.textContent = 'Taking you to checkout…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add this size'); });
      window.location.href = '/checkout';
    }).catch(function (err) {
      btn.disabled = false;
      btn.textContent = err.message || LABEL;
      setTimeout(function () { btn.textContent = LABEL; }, 3000);
    });
  }

  function makeBtn(attr) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'ff-btn ff-btn--dark ff-btn--block ff-buy';
    b.setAttribute(attr, '');
    b.textContent = LABEL;
    /* Dark ink fill so it reads as the main action next to the beige Add to cart */
    b.style.setProperty('background', '#2B2320', 'important');
    b.style.setProperty('color', '#F6F0E6', 'important');
    return b;
  }

  function nudge(btn, sizes) {
    btn.textContent = 'Choose your size first';
    if (sizes) sizes.scrollIntoView({ behavior: 'smooth', block: 'center' });
    setTimeout(function () { btn.textContent = LABEL; }, 2200);
  }

  /* Coming back from checkout with the back button: reset the button */
  window.addEventListener('pageshow', function () {
    Array.prototype.forEach.call(document.querySelectorAll('.ff-buy'), function (b) { b.disabled = false; b.textContent = LABEL; });
  });

  /* ---------- product page ---------- */
  var pdp = document.querySelector('[data-ff-pdp]');
  if (pdp) {
    var add = pdp.querySelector('[data-pdp-add]');
    var input = pdp.querySelector('input[name="id"]');
    if (add && input && !pdp.querySelector('[data-pdp-buy]')) {
      var pb = makeBtn('data-pdp-buy');
      pb.style.minHeight = '56px';
      pb.style.fontSize = '16px';
      add.insertAdjacentElement('afterend', pb);
      pb.addEventListener('click', function () {
        if (!input.value) { nudge(pb, pdp.querySelector('[data-pdp-sizes]')); return; }
        addThenCheckout(input.value, pb);
      });
    }
  }

  /* ---------- quick view ---------- */
  var qv = document.getElementById('ff-qv');
  if (qv) {
    var qadd = qv.querySelector('[data-qv-add]');
    var current = null, picked = null;
    /* Capture phase: runs before the quick view opens, so we know which product and size is shown */
    document.addEventListener('click', function (e) {
      var open = e.target.closest('[data-ff-qv]');
      if (open) {
        var card = open.closest('[data-ff-card]');
        var json = card && card.querySelector('script[data-ff-product]');
        try { current = json ? JSON.parse(json.textContent) : null; } catch (x) { current = null; }
        picked = null;
      }
      var size = e.target.closest('#ff-qv .ff-size');
      if (size && current && !size.disabled) {
        picked = null;
        current.variants.forEach(function (v) { if (String(v.title) === size.textContent.trim()) picked = v; });
      }
    }, true);
    if (qadd && !qv.querySelector('[data-qv-buy]')) {
      var qb = makeBtn('data-qv-buy');
      qadd.insertAdjacentElement('afterend', qb);
      qb.addEventListener('click', function () {
        if (!picked) { nudge(qb, qv.querySelector('[data-qv-sizes]')); return; }
        addThenCheckout(picked.id, qb);
      });
    }
  }
})();
